import { j as s } from "./AccesRecoveryIcon-CUPieIxT.js";
const l = () => /* @__PURE__ */ s.jsxs("svg", { viewBox: "0 0 40 41", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M10.145 12.765a.54.54 0 0 1-.402-.182c-.636-.71-1.631-1.83-1.859-2.068Q6.81 10.1 5.687 9.843a.52.52 0 0 1-.39-.41.53.53 0 0 1 .198-.532c.395-.299 1.49-1.148 1.778-1.447.131-.192.334-1.28.42-2.314a.533.533 0 0 1 .955-.277q.746 1.019 1.596 1.951a18 18 0 0 0 2.254.413.52.52 0 0 1 .44.355.53.53 0 0 1-.141.569c-.256.227-1.465 1.3-1.895 1.635a13.5 13.5 0 0 0-.238 2.456.533.533 0 0 1-.533.523z",
      fill: "#F1940C"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M8.237 5.183s1.489 1.969 1.777 2.1c.416.2 2.442.47 2.442.47s-1.632 1.454-1.934 1.663-.355 2.816-.355 2.816-1.664-1.877-1.91-2.133c-.244-.256-2.416-.786-2.416-.786s1.45-1.105 1.845-1.496c.394-.391.572-2.648.572-2.648m0-1.067a1.07 1.07 0 0 0-.825.392c-.138.168-.22.373-.238.59-.041.69-.153 1.375-.334 2.043-.316.288-1.134.931-1.667 1.337a1.066 1.066 0 0 0 .387 1.884q1.02.244 2.009.593c.295.32 1.173 1.301 1.777 1.984a1.07 1.07 0 0 0 1.155.291 1.07 1.07 0 0 0 .711-.977q.014-1.09.167-2.169c.483-.398 1.361-1.173 1.777-1.535a1.067 1.067 0 0 0-.568-1.856c-.754-.103-1.682-.256-2.044-.355-.274-.288-.932-1.113-1.45-1.802a1.07 1.07 0 0 0-.854-.423z",
      fill: "#270E0F"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M20.425 39.56c9.91 0 17.944-8.035 17.944-17.944 0-9.91-8.034-17.944-17.944-17.944S2.481 11.706 2.481 21.616s8.034 17.943 17.944 17.943",
      fill: "#F1940C"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M20.425 4.383a17.233 17.233 0 1 1 .014 34.465 17.233 17.233 0 0 1-.014-34.465m0-1.422A18.655 18.655 0 1 0 39.08 21.616 18.676 18.676 0 0 0 20.425 2.96",
      fill: "#270E0F"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M27.926 37.351c9.246-3.83 13.637-14.43 9.807-23.676-3.83-9.247-14.43-13.637-23.677-9.807S.42 18.298 4.25 27.544c3.83 9.247 14.43 13.637 23.677 9.807",
      fill: "#F1940C"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M20.99 3.377a17.233 17.233 0 1 1-.007 34.465 17.233 17.233 0 0 1 .008-34.465m0-1.777A19.01 19.01 0 1 0 40 20.617 19.035 19.035 0 0 0 20.99 1.6",
      fill: "#270E0F"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M20.99 35.78c8.38 0 15.171-6.792 15.171-15.17 0-8.38-6.792-15.172-15.17-15.172-8.38 0-15.172 6.793-15.172 15.172 0 8.378 6.793 15.17 15.171 15.17",
      fill: "#FCBD1A"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M8.236 5.183s-.18 2.253-.572 2.648c-.39.394-1.845 1.496-1.845 1.496s2.176.544 2.417.786c.242.242 1.91 2.133 1.91 2.133s.06-2.602.355-2.816 1.94-1.677 1.94-1.677-2.026-.27-2.441-.47c-.274-.131-1.764-2.1-1.764-2.1",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ s.jsxs("g", { opacity: ".3", children: [
    /* @__PURE__ */ s.jsx("mask", { id: "a", maskUnits: "userSpaceOnUse", x: "5", y: "5", width: "14", height: "15", children: /* @__PURE__ */ s.jsx("path", { d: "m5.435 19.632 3.508-3.451 9.925-10.77-5.84.817-7.835 8.591z", fill: "#fff" }) }),
    /* @__PURE__ */ s.jsx("g", { mask: "url(#a)", children: /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M20.866 35.845c8.38 0 15.171-6.792 15.171-15.171S29.245 5.503 20.867 5.503c-8.38 0-15.172 6.792-15.172 15.171s6.793 15.171 15.171 15.171",
        fill: "#fff"
      }
    ) })
  ] }),
  /* @__PURE__ */ s.jsx("mask", { id: "b", maskUnits: "userSpaceOnUse", x: "-1", y: "0", width: "33", height: "32", children: /* @__PURE__ */ s.jsx("path", { d: "M5.718 21.598 27.043 0l4.766 2.95L2.722 31.538l-2.723-4.582z", fill: "#fff" }) }),
  /* @__PURE__ */ s.jsx("g", { mask: "url(#b)", children: /* @__PURE__ */ s.jsx(
    "path",
    {
      opacity: ".3",
      d: "M20.904 35.909c8.378 0 15.17-6.793 15.17-15.172 0-8.378-6.792-15.17-15.17-15.17-8.38 0-15.172 6.792-15.172 15.17 0 8.38 6.793 15.171 15.172 15.171",
      fill: "#fff"
    }
  ) }),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M20.99 32.741c6.7 0 12.132-5.431 12.132-12.132S27.691 8.478 20.99 8.478 8.858 13.909 8.858 20.609 14.29 32.741 20.99 32.741Z",
      fill: "#763910",
      stroke: "#BD6816"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M16.458 14.773s1.998-5.037 4.585-5.083c2.588-.046 4.312 5.31 4.312 5.31s5.286.068 6.306 2.336-3.555 4.902-3.555 4.902 1.568 5.31.16 6.533c-1.407 1.223-5.492-.523-7.262-1.45 0 0-4.422 2.697-7.077 1.631-1.61-1.041-.181-6.626-.181-6.626s-4.198-2.843-3.52-5.058c.68-2.214 6.232-2.495 6.232-2.495Z",
      fill: "#FCBE1A",
      stroke: "#DC7E0C"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      opacity: ".3",
      d: "m23.126 27.84 4.93-4.838.38 3.81-2.075 1.98s-2.844-.256-3.235-.952m-4.908 4.902s2.996 1.997 7.465.575 5.356-5.296 5.356-5.296-2.339 3.412-6.398 4.51c-4.06 1.1-6.423.21-6.423.21M14.13 22.188l9.768-9.665s-1.305-2.456-2.844-2.51c-1.728-.06-3.84 3.395-4.347 5.073 0 0-3.651.249-4.447.874l-1.728 2.169s.455 2.03 3.598 4.059",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ s.jsx("path", { d: "M24.268 21.47a2.001 2.001 0 1 0 0-4.003 2.001 2.001 0 0 0 0 4.003", fill: "#000" }),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M23.649 19.166a.522.522 0 1 0 0-1.045.522.522 0 0 0 0 1.045m1.223 1.938a.242.242 0 1 0 0-.484.242.242 0 0 0 0 .483",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ s.jsx("path", { d: "M17.71 21.47a2.001 2.001 0 1 0 0-4.003 2.001 2.001 0 0 0 0 4.003", fill: "#000" }),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M17.044 19.166a.522.522 0 1 0 0-1.045.522.522 0 0 0 0 1.045m1.227 1.938a.242.242 0 1 0 0-.484.242.242 0 0 0 0 .483",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ s.jsx("path", { d: "m19.06 16.419.881.792m2.109 0 .878-.792", stroke: "#010101" }),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M23.482 21.847c-.313-.153-1.166-.132-1.835-.082q-.888.064-1.777 0c-.668-.05-1.521-.071-1.838.082-.494.241-1.521.995-.824 2.253a2.45 2.45 0 0 0 1.112 1.017 5.2 5.2 0 0 0 1.87.476q.581.032 1.162 0a5.3 5.3 0 0 0 1.842-.497 2.43 2.43 0 0 0 1.112-1.017c.697-1.237-.327-1.99-.825-2.232Z",
      fill: "#fff",
      stroke: "#1E1E1C"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M20.759 21.761v3.832M19.5 21.761l-1.265 3.217m3.815-3.217 1.322 3.33m.11-3.244c-.313-.153-1.166-.132-1.835-.082q-.888.064-1.777 0c-.668-.05-1.521-.071-1.838.082-.494.241-1.521.995-.824 2.253a2.45 2.45 0 0 0 1.112 1.017 5.2 5.2 0 0 0 1.87.476q.581.032 1.162 0a5.3 5.3 0 0 0 1.842-.497 2.43 2.43 0 0 0 1.112-1.017c.697-1.237-.327-1.99-.825-2.232Z",
      stroke: "#1E1E1C"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      opacity: ".3",
      d: "m18.615 35.596 1.731-2.016q1.204.22 2.428.249l-2.047 1.973s-1.678-.04-2.112-.206m14.653-17.233 2.31-1.927c.28.91.455 1.849.519 2.798l-2.684 2.63a11.3 11.3 0 0 0-.145-3.5",
      fill: "#fff"
    }
  )
] });
export {
  l as T
};
